// initializing 
(function() {
  $(document).ready(function() {
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    SwellConfig.LocalStorage.initializeLocalStorage();

    $('body').on('click', '.question', function ()
      {
        if ($(this).hasClass("open"))
        {
          $(this).removeClass("open");
          $(this).siblings().removeClass("open");
        }
        else
        {
          $(this).addClass("open");
          $(this).siblings().addClass("open");
        }
      });
  });

  $(document).on("swell:setup", function() {
    SwellConfig.Tier.initializeTiers();
    SwellConfig.Customer.initializeHistory(".swell-history-link");

    $(".swell-post-checkout").css("display", "flex");
    $( 'body' ).on('click',".swell-post-checkout .checkout-heading .swell-referral-back-link", function() {
      $(".swell-post-checkout").hide();
    });
  });
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    setupCustomerTierStatus: function() {
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();

      width = parseFloat($(".slider-div").css("width"));
      height = parseFloat($(".slider-div").css("height"));

      if(spapi.customer.vip_tier_stats) {
        var i;
        for (i = 1; i <= spapi.customer.vip_tier_stats.referrals_completed; i++) {
          $("[data-tier="+i+"]").addClass("active");
        }
      }

      width = (width * spapi.customer.vip_tier_stats.referrals_completed) + 15;
      height = (height / spapi.customer.vip_tier_stats.referrals_completed) + 15;
      $(".slider-div").css("width", width + "px");
      $(".slider-div").css("height", height + "px");

      if(spapi.customer.vip_tier) {
        $("[data-tier-id="+ customer_tier_id+"]").addClass("active");
      }
    },
    initializeTiers: function(containerSelector) {
      if (spapi.authenticated) {

        if(spapi.customer.vip_tier_stats) {
          $(".swell-refer-completed").html(spapi.customer.vip_tier_stats.referrals_completed)
        } else {
          $(".swell-refer-completed").html(0)
        }

        if(spapi.customer.vip_tier) {
          $(".tier-name").html(spapi.customer.vip_tier.name);
        } else {
          $(".member-heading").html('keep referring to be Silver member');
          $(".member-heading").css("font-size", "12px");
        }


        var centsPerPoint = spapi.activeVariableRedemptionOptions[0].discount_rate_cents;
        var balanceAvailable = parseFloat(
          spapi.customer.adjusted_points_balance * centsPerPoint / 100.0
        ).toFixed(2);

        customerBalance = balanceAvailable;
        $(".yotpo-friends-emails-view").append('<div class="your-rewards"><div class="swell-rewards">Your Rewards : $' +customerBalance +'</div> <ul class="swell-link-list"> <li class="swell-link"> <a href="/checkout">redeem now</a> </li></ul><div>');

        SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };
}).call(this);
